var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"label":_vm.$t('chat.filterClosed'),"data-testid":"sms-context-menu-closed"},model:{value:(_vm.closedFilter),callback:function ($$v) {_vm.closedFilter=$$v},expression:"closedFilter"}})}
var staticRenderFns = []

export { render, staticRenderFns }